import React from 'react';
import { Tabs, Typography, Card, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import MeasuringInstrumentInventoryForm from './Form';
import MeasuringInstrumentCalibrationList from '../../measuring-instrument-calibrations/views/List';
import MeasuringInstrumentInspectorList from '../../measuring-instrument-inspectors/views/List';
export default function MeasuringInstrumentInventoryDetail(){
  const { id } = useParams();
  const navigate = useNavigate();
  const referenceId = Number(id);
  const items = [
    { key: 'tab0', label: 'Ölçüm Cihazı Envanteri', children: <MeasuringInstrumentInventoryForm id={Number(id)} onSuccess={() => {}} reloadAfterSave /> },
    { key: 'tab1', label: 'Kalibrasyon Bilgileri', children: <MeasuringInstrumentCalibrationList referenceId={referenceId} /> },
    { key: 'tab2', label: 'P.K.M Uzmanı', children: <MeasuringInstrumentInspectorList referenceId={referenceId} /> }
  ];
  return (
    <Card className='br-30px'>
      <Tabs
        items={items}
        tabBarExtraContent={{
          right: (
            <Button onClick={() => navigate('/settings/measuring-instrument-inventories')} className='d-button action-button'>
              Geri
            </Button>
          )
        }}
      />
    </Card>
  );
}
